import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

/**
 * 返回语言
 * en / zh
 */
export function getLanguage() {
  let lang = 'en-US'

  const cookieLanguage = Cookies.get('sr.language')
  if (cookieLanguage) lang = cookieLanguage
  // else {
  //   // cookies没有找到语言则通过浏览器语言判断
  //   const browswerLanguage = navigator.language || navigator.browserLanguage
  //   if (browswerLanguage) lang = browswerLanguage
  // }

  const locales = Object.keys(messages)

  for (const locale of locales) {
    if (lang.toLowerCase().indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
})

export default i18n
